import React from "react";
import { NewNavbar } from "../Pages/NewNavbar";
import Footer from "../Footer";

export default function Magazine() {
  return (
    <>
      <NewNavbar />
      <div className="bookFrame" style={{ height: "100vh", width: "100%" }}>
        <iframe
          src="https://d3ms8mre5rhtvu.cloudfront.net?hash=QkQ4OUFBQkJEQzkrNzFpcWh6eDRvdA=="
          width="100%"
          height="100%"
          scrolling="no"
          frameBorder="0"
          allowFullScreen
          allow="autoplay; clipboard-read; clipboard-write"
        ></iframe>
      </div>

      <Footer activeSection="" />
    </>
  );
}
